import { render, staticRenderFns } from "./lojaCard.vue?vue&type=template&id=32e15044&"
import script from "./lojaCard.vue?vue&type=script&lang=js&"
export * from "./lojaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports